import {
  component_mobile_styles_default
} from "./chunk.3DO35SD7.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// node_modules/@shoelace-style/shoelace/dist/styles/component.styles.js
var component_styles_default = r` :host { box-sizing: border-box; } :host *, :host *::before, :host *::after { box-sizing: inherit; } [hidden] { display: none !important; } `;

// src/styles/component.styles.ts
var component_styles_default2 = r` ${component_styles_default} ${component_mobile_styles_default} * { box-sizing: border-box; } `;

export {
  component_styles_default2 as component_styles_default
};
